import { Grid, Stack, useTheme } from "@mui/material";
import sanitizeHtml from "utils/sanitizeHtml";

type GtcContentProps = {
  html?: string;
};

const GtcContent = ({ html = "" }: GtcContentProps) => {
  const theme = useTheme();
  const sanitizedHtml = sanitizeHtml(html);
  const gtcContentSx = {
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: 1.5,
    textAlign: "justify" as const,
    "& b": {
      fontWeight: 600,
    },
    "& strong": {
      fontWeight: 600,
      fontSize: "1rem",
    },
    "& u": {
      textDecoration: "underline",
    },
    "& ul": {
      paddingLeft: "1.5rem",
      marginBottom: "0.75rem",
    },
    "& ol": {
      paddingLeft: "1.5rem",
      marginBottom: "0.75rem",
    },
    "& p": {
      marginBottom: "0.75rem",
    },
  };

  return (
    <Grid
      item
      sx={{
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2ch",
        padding: "2ch",
        height: "inherit !important",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      <Stack
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        margin="auto"
        sx={gtcContentSx}
      />
    </Grid>
  );
};

export default GtcContent;
